(() => {
  const backButton = document.querySelector('[data-gk-back]');
  if (backButton) {
    backButton.addEventListener('click', (event) => {
      let sameSiteReferrer = false;
      try {
        sameSiteReferrer = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        sameSiteReferrer = false;
      }
      if (sameSiteReferrer && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  const template = document.getElementById('gk-drawer-template');
  if (!template) return;

  const openers = document.querySelectorAll('[data-gk-drawer-open]');
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  let drawer = null;
  let panel = null;
  let lastFocused = null;

  const setExpanded = (value) => openers.forEach((el) => el.setAttribute('aria-expanded', String(value)));

  const mount = () => {
    if (drawer) return;
    template.parentNode.insertBefore(template.content.cloneNode(true), template);
    drawer = document.querySelector('[data-gk-drawer]');
    panel = drawer.querySelector('.gk-drawer__panel');
    openers.forEach((el) => el.setAttribute('aria-controls', drawer.id));
    drawer.querySelectorAll('[data-gk-drawer-close]').forEach((el) => el.addEventListener('click', close));
    bindTabs();
  };

  const open = () => {
    mount();
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.documentElement.classList.add('gk-scroll-lock');
    setExpanded(true);
    panel.querySelector('.gk-drawer__close')?.focus();
  };

  const close = () => {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('gk-scroll-lock');
    setExpanded(false);
    const finish = () => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    };
    panel.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 400);
    lastFocused?.focus?.();
  };

  openers.forEach((el) => el.addEventListener('click', open));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
  desktopQuery.addEventListener('change', (event) => {
    if (event.matches) close();
  });

  function bindTabs() {
    const tabs = [...drawer.querySelectorAll('[data-gk-tab]')];
    const panes = [...drawer.querySelectorAll('.gk-cats__pane')];
    const paneScroller = drawer.querySelector('.gk-cats__panes');

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panes.forEach((pane, i) => {
        pane.hidden = i !== index;
      });
      if (paneScroller) paneScroller.scrollTop = 0;
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', (event) => {
        const step = { ArrowDown: 1, ArrowUp: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        select((i + step + tabs.length) % tabs.length, true);
      });
    });
  }
})();
